import { useAuth } from "@/contexts/AuthContext";

/**
 * Role helpers
 *   isAdmin       — admin only (full delete/restore power)
 *   canWrite      — anyone who can create/update records
 *                   = office staff with role admin|tester  OR  any active employee
 *   canDelete     — admin only
 *   canRead       — any authenticated principal
 *   isEmployee    — true when logged in via the Test Person PIN flow
 */
export function useRole() {
  const { user, kind } = useAuth();
  const role = user && typeof user === "object" ? user.role : null;
  const isEmployee = kind === "employee";
  return {
    role,
    kind,
    isEmployee,
    isAdmin: !isEmployee && (role === "admin" || role === "super-admin"),
    isSuperAdmin: !isEmployee && role === "super-admin",
    canWrite: isEmployee || role === "admin" || role === "super-admin" || role === "tester",
    canDelete: !isEmployee && (role === "admin" || role === "super-admin"),
    canRead: !!role,
  };
}

export const ROLE_LABEL = {
  "super-admin": "Super-admin",
  admin: "Admin",
  tester: "Tester",
  "read-only": "Read-only",
};
